import { createTheme } from '@mui/material/styles';
const theme = createTheme();

/**
 * Typography
 * https://lumahealth.clickup.com/t/864egg6k5
 *
 * Demos:
 *
 * - [Typography](https://ui-packages.isbuildingluma.com/ui-core/react-typography/)
 *
 * API:
 *
 * - [Typography API](https://ui-packages.isbuildingluma.com/ui-core/api/typography/)
 * - inherits [MuiTypography API](https://mui.com/material-ui/api/typography/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Design-System-Playground?node-id=287-19010&t=ThpkQmayVOTVUeMn-0)
 */
const typography = {
  fontFamily: 'halyard-display, sans-serif',
  h1: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(36),
    lineHeight: 1.325,
    letterSpacing: '.01rem'
  },
  h2: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: 1.25,
    letterSpacing: '.01rem'
  },
  h3: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(28),
    lineHeight: 1.285,
    letterSpacing: '.01rem'
  },
  h4: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(24),
    lineHeight: 1.325,
    letterSpacing: '.01rem'
  },
  h5: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(20),
    lineHeight: 1.2,
    letterSpacing: '.01rem'
  },
  h6: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    letterSpacing: '.02rem'
  },
  subtitle1: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    letterSpacing: '0rem'
  },
  subtitle2: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    letterSpacing: '0rem'
  },
  subtitle3: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.5,
    letterSpacing: '.01rem'
  },
  body1: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.5,
    letterSpacing: '0rem'
  },
  body2: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.425,
    letterSpacing: '0rem'
  },
  button: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.425,
    letterSpacing: '-0.01rem',
    textTransform: 'initial'
  },
  caption: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.5,
    letterSpacing: '.01rem'
  },
  overline: {
    fontFamily: 'halyard-text, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(10),
    lineHeight: 1.6,
    letterSpacing: '.02rem',
    textTransform: 'initial'
  }
};
export default typography;